import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AppSpan, AppText, Button, CustomContainer, FlexRow, ScreenContainer, ScreenTitle } from "src/style"
import {ReactComponent as NoUserIcon} from 'src/assets/svg/no-user-icon.svg'
import utility from "src/utils/utility"
import { ServerSideTable } from 'src/component'
import { usersColumn, usersData } from 'src/utils/tableLayout'
import { User, UserType } from 'src/model'
import { NewUserBasics, NewUserRole, NewUserSetupCompletion, NewUserSetupSummary } from 'src/popup'

const Users = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {userType}} = useContext(AppInfoContext)
    const [usersInfo, setUsersInfo] = useState<any>(null)
    const [users, setUsers] = useState<Array<User>|null>([])
    const [selectedUser, setSelectedUser] = useState<User|null>(null)
    const [view, setView] = useState('')

    useEffect(() => {
        if (userType) handleFetchUsers()
    }, [userType]) 

    async function handleFetchUsers (pageNumber = 1, pageSize = 10) {
        const response = userType === UserType.ADMIN ? 
            await API.getAdminUsers({page: pageNumber, size: pageSize})
            : await API.getOrganizationStaffs({page: pageNumber, size: pageSize})

        if (response) {
            setUsersInfo(response)
            setUsers(response.data)
        }
    }

    async function handleAction (data: User, option: string) {
        if (option === 'edit') {
            setSelectedUser(data)
            setView('new-user')
            //navigate('/dashboard/users/user-basics')
        }
        else {
            const response = await API.revokeStaffAccess(data.id)
            if (response) handleFetchUsers()
        }
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <ScreenTitle 
                    color='#333333' 
                    textSize='2.4' 
                    fontWeight='700'
                >
                    User Roles
                </ScreenTitle>

                { (users && users?.length > 0) &&
                    <FlexRow 
                        gap='2.5' topMargin='4'
                        wrap='wrap'
                        justifyContent='space-between' 
                    >
                        <AppText 
                            textSize='1.6' 
                            fontWeight='600' 
                            color='#111111'
                        >
                            Active Users
                        </AppText>
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            onClick={() => setView('new-user')}
                        >
                            Add User
                        </Button>
                    </FlexRow>
                }
                <CustomContainer 
                    topMargin='4'
                    className='no-user-container'
                >
                    <ServerSideTable
                        tableColumns={usersColumn(handleAction)}
                        tableData={users}
                        dataFetchMethod={handleFetchUsers}
                        totalRows={usersInfo?.totalResults}
                        noDataText={
                            <>
                                <AppText 
                                    textSize="1.6" 
                                    color="#000000" 
                                    fontWeight="700"
                                    align='center'
                                >
                                    No users added yet
                                </AppText>
                                <AppSpan textSize="1.6" color="#000000" align='center'>
                                    You have not added any users yet. 
                                </AppSpan>
                            </>
                        }
                        noDataCustomIcon={ <NoUserIcon className="icon-component" /> }
                        actionComponent={ 
                            <Button 
                                width='22.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                                topMargin='3'
                                onClick={() => setView('new-user')}
                            >
                                Add User
                            </Button>
                        }
                    />
                </CustomContainer>
            </ScreenContainer>
            { view === 'new-user' &&
                <NewUserBasics
                    close={() => setView('')}
                    next={() => setView('new-user-role')}
                    selectedUser={selectedUser}
                />
            }
            { view === 'new-user-role' &&
                <NewUserRole
                    close={() => setView('')}
                    back={() => setView('new-user')}
                    next={() => setView('user-setup-summary')}
                    selectedUser={selectedUser}
                />
            }
            { view === 'user-setup-summary' &&
                <NewUserSetupSummary
                    close={() => setView('')}
                    back={() => setView('new-user-role')}
                    next={() => setView('user-setup-completion')}
                    fetchUpdatedUsers={handleFetchUsers}
                    selectedUser={selectedUser}
                />
            }
            { view === 'user-setup-completion' &&
                <NewUserSetupCompletion
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('users', 'Users', <Users/>)